// Contrail V3.11.0 — break-glass page /status-admin: post or end platform notices with the status key (STATUS_ADMIN_KEY)
// when Supabase sign-in isn't working. Needs no sign-in and makes no Supabase calls. The key is kept for this tab only.
import { FormEvent, useMemo, useState } from "react";
import StatusAdmin, { statusApi } from "./admin/StatusAdmin";

const SS = "fw.statuskey";
const readKey = () => { try { return sessionStorage.getItem(SS) ?? ""; } catch { return ""; } };

export default function StatusKeyPage() {
  const [key, setKey] = useState(readKey);
  const [entry, setEntry] = useState("");
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const api = useMemo(() => (key ? statusApi({ key }) : null), [key]);

  async function unlock(e: FormEvent) {
    e.preventDefault();
    setBusy(true); setErr(null);
    try {
      await statusApi({ key: entry.trim() })("GET", "?all=1");
      try { sessionStorage.setItem(SS, entry.trim()); } catch { /* storage off */ }
      setKey(entry.trim());
    } catch (x: any) { setErr(x.message); }
    finally { setBusy(false); }
  }
  function lock() { try { sessionStorage.removeItem(SS); } catch { /* */ } setKey(""); setEntry(""); }

  if (!api) {
    return (
      <div className="login"><form className="login-card" onSubmit={unlock}>
        <img src="/tf-logo.png" alt="Tracking Fiji" style={{ height: 40, alignSelf: "flex-start" }} />
        <h1>Platform notices</h1>
        <p className="muted">For Skyward when the normal sign-in isn't working. Enter the status key (kept in the password manager).</p>
        <input type="password" autoComplete="off" value={entry} onChange={(e) => setEntry(e.target.value)} placeholder="Status key" required />
        {err && <div className="error" role="alert">{err}</div>}
        <button className="btn-primary" disabled={busy}>{busy ? "Checking…" : "Open"}</button>
        <a className="muted" href="/login" style={{ fontSize: 13 }}>← Normal sign-in</a>
      </form></div>
    );
  }
  return (
    <div className="admin">
      <header className="topbar">
        <img src="/logo.png" alt="Tracking Fiji" className="topbar-logo" />
        <span className="beta">Status key</span>
        <div className="topbar-spacer" />
        <a className="btn-ghost" href="/login">Sign-in page</a>
        <button className="btn-ghost" onClick={lock}>Lock</button>
      </header>
      <main className="amain"><StatusAdmin api={api} breakGlass /></main>
    </div>
  );
}
